<template>
  <div class="scored_box">
    <div class="header">
      <div class="header_title">{{ listData.title }}</div>
      <div class="header_time">进入重点关注时间：{{ listData.enteredTime | filtTime }}</div>
      <div class="header_lastTime">剩余评价时间：{{ listData.residue }}</div>
    </div>
    <div class="exitSupervision_bottom">
      <div class="result line_bottom">
        <div class="title">
          <div>评分对象信息</div>
        </div>
      </div>
      <div class="toBeRectified">
        <div class="companyName line_bottom">
          <div class="left">企业名称</div>
          <div class="right" @click="goTaskDetail">
            <span>{{ listData.enterpriseName }}</span>
            <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
          </div>
        </div>
        <div class="jurisdiction line_bottom">
          <div class="left">所属辖区</div>
          <div class="right">{{ listData.regionName }}</div>
        </div>
        <div class="supervisionDate line_bottom">
          <div class="left">进入重点关注日期</div>
          <div class="right">{{ listData.enteredTime | filtTime }}</div>
        </div>
        <div class="supervisionDate integrityIndex">
          <div class="left"><span>诚信指数</span></div>
          <div class="right">
            <span @click="goGradeDetail">监管详情</span>
            <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
          </div>
        </div>
        <div class="integrity_scored">
          <div class="integrity_scored_box">
            <div class="integrity_scored_current"><span class="current">{{ listData.score }}</span> 分</div>
            <div class="integrity_scored_title">当前评分</div>
          </div>
          <div class="integrity_scored_box">
            <div class="integrity_scored_bringInto"><span class="bringInto">{{ listData.enterScore }}</span> 分</div>
            <div class="integrity_scored_title">纳入评分</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBtn">
      <div class="btn" @click="goTo">发布任务</div>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';

    export default {
        data () {
            return {
                listData: {}
            }
        },
        created () {
            this.getSupervisionWarning();
        },
        methods: {
            getSupervisionWarning () {
                if (this.$route.query.type == 'toScore') {
                    // 重点关注企业待评分
                    api.supervisionToScore({ taskId: this.$route.query.taskId }).then(res => {
                        if (res.ret === 0) {
                            this.listData = res.data;
                        }
                    })
                }
                if (this.$route.query.type == 'warning') {
                    // 黑名单预警企业待评分
                    api.supervisionWarning({ taskId: this.$route.query.taskId }).then(res => {
                        if (res.ret === 0) {
                            this.listData = res.data;
                        }
                    })
                }
            },
            // 企业名称
            goTaskDetail () {
                this.$router.push({
                    path: 'enterpriseDetail',
                    query: {
                        enterpriseId: this.listData.enterpriseId
                    }
                })
            },
            // 监管详情
            goGradeDetail () {
                this.$router.push({
                    path: 'scoreDetails',
                    query: {
                        id: this.listData.enterpriseId
                    }
                })
            },
            // 发布任务
            goTo () {
                this.$router.push({
                    path: '/integrity/sendTask',
                    query: {
                        enterpriseGradeId: this.listData.enterpriseGradeId,
                        enterpriseName: this.listData.enterpriseName,
                        title: this.listData.title,
                        score: this.listData.score,
                        id: this.$route.query.id
                    }
                })
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
                var D =
                    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
                var h =
                    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
                var m =
                    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
                    ":";
                var s =
                    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    }
</script>
<style lang="less" scoped>
.scored_box {
  padding: 20px 12px 0px;
  .header {
    width:351px;
    height:104px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    padding: 16px;
    .header_title {
      font-size:16px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(51,51,51,1);
      line-height:16px;
    }
    .header_time {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:14px;
      padding: 16px 0px;
    }
    .header_lastTime {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:14px;
    }
  }
  .exitSupervision_bottom {
    width: 100%;
    background-color: #fff;
    float: left;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-bottom: 94px;
    margin-top:16px;
    .result {
      width: 100%;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
      }
    }
    .toBeRectified {
      width: 100%;
      height: 100%;
      .companyName,
      .jurisdiction,
      .supervisionDate {
        height: 62px;
        width: 100%;
        line-height: 62px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        .left {
          color: #999;
        }
      }
      .jurisdiction{
        .right{
          width: 160px;
          text-align: right;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .companyName {
        line-height: center;
        .right{
          display: flex;
          justify-content: space-around;
          span{
            display: inline-block;
            width: 160px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          img{
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-left: 4px;
            margin-top: 24px;
          }
        }
      }
      .integrityIndex {
        height: 60px;
        width: 100%;
        line-height: 60px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left{
          // display: flex;
          // align-items: center;
        }
        .right {
          span {
            float: left;
          }
          img {
            display: inline-block;
            float: right;
            width: 12px;
            height: 12px;
            margin-left: 4px;
            margin-top: 24px;
          }
        }
      }
      .integrity_scored {
        display: flex;
        justify-content: space-around;
        .integrity_scored_box {
          margin: 12px 16px 24px 16px;
          .integrity_scored_current {
            color: #36B374;
            font-size: 10px;
            span {
              font-size: 20px;
              font-weight:bold;
            }

          }
          .integrity_scored_bringInto {
            color: #FF4D4D;
            font-size: 10px;
            span {
              font-size: 20px;
              font-weight:bold;
            }
          }
          .integrity_scored_title {
            margin-top: 8px;
            color: #999999;
            font-size:12px;
            font-weight:400;
          }
        }
      }
    }
  }
  .bottomBtn {
    width:100%;
    height:73px;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
    position: fixed;
    bottom: 0px;
    left: 0px;
    padding: 12px;
    z-index: 99;
    .btn {
      width:351px;
      height:50px;
      background:rgba(54,179,116,1);
      border-radius:3px;
      line-height: 50px;
      color: #fff;
      font-size: 16px;
      text-align: center;
    }
  }
}
</style>
